import { Subject } from 'rxjs';
const notify = new Subject();

export { notify }